module.exports = __webpack_public_path__ + "static/media/magic bricks _tree house.13e558c6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/magic bricks _tree house.gif
// module id = 353
// module chunks = 0